export default __webpack_public_path__ + "static/media/speaker32.0ccde16a.png";